<template>
  <div class="mr-8 py-2">
    <a :href="`/optins/${id}`" class="text-sm font-medium text-primary-60">
      <slot />
    </a>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  id: string;
}>();
</script>
